import { call, put, select } from 'redux-saga/effects';
import {
  lockedContentChanged,
  selectCurrentOpenedContent,
  selectLockedContent,
} from 'features/layout/features/content/contentSlice';
import { currentActiveFileUpdated } from 'features/content-library/contentLibrarySlice';
import { SignalingSocket } from 'services/signaling';
import { ContentData, PushContentData } from 'features/layout/features/content/types';
import { selectZoomState } from 'features/content-zoom/contentZoomSlice';
import { ZoomState } from 'features/content-zoom/types';
import { toServerScale, buildZoomId } from 'features/content-zoom/utils/formatUtils';
import { LOCKED_ZOOM_CONTENT_TYPES } from 'features/content-zoom/constants';

export function* sendPushContentSaga(lock: boolean) {
  const currentContent: ContentData = yield select(selectCurrentOpenedContent);

  if (!currentContent) {
    return;
  }

  const lockedContent: ContentData = yield select(selectLockedContent);

  if (currentContent.type === 'whiteboard' || currentContent.type === 'file') {
    yield put(currentActiveFileUpdated(currentContent.id));
  }

  if (lockedContent && !lock) {
    yield put(lockedContentChanged(null));
  }

  const data: PushContentData = {
    type: currentContent.type,
    id: currentContent.id,
    page: currentContent.page,
    lock,
  };

  if (lock && LOCKED_ZOOM_CONTENT_TYPES.includes(currentContent.type)) {
    const lockedZoomId = buildZoomId(currentContent.id, currentContent.page);
    const zoomData: ZoomState | undefined = yield select(selectZoomState, lockedZoomId);

    if (zoomData) {
      data.scale = toServerScale(zoomData.scale);
      data.offsetX = zoomData.offsetX;
      data.offsetY = zoomData.offsetY;
    }
  }

  yield call(SignalingSocket.send, {
    event: 'pushContent',
    data,
  });
}
